module.exports = __webpack_public_path__ + "5c3cfa2f642bc5a9bcf2d1a3d32b1f9c.png";